import { Base } from '../types/GenericFormTypes';

export const mapNameAndIdToLabelAndValue = (resource: Base) => ({
  label: resource.name,
  value: resource.id!,
});
